import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { CommonService } from './../common.service';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from "ngx-spinner";
import { SelectDropDownComponent } from 'ngx-select-dropdown';
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';
import { formatNumber } from '@angular/common';
import { CommonVariablesService } from './../common-variables.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { HttpClient } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import * as Excel from "exceljs/dist/exceljs.min.js";
import { noop, Observable, Observer, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { from } from 'rxjs';



@Component({
  selector: 'app-detailed-statement-of-accounts',
  templateUrl: './detailed-statement-of-accounts.component.html',
  styleUrls: ['./detailed-statement-of-accounts.component.css']
})
export class DetailedStatementOfAccountsComponent implements OnInit {
  @ViewChild(SelectDropDownComponent, { "static": false })
  ngxselectRef: SelectDropDownComponent
  detailedSOAForm: FormGroup;
  submitted = false;
  dtTrigger: Subject<any> = new Subject();
  dtOptions: any;
  detailedFromDate: any;
  detailedToDate: any;
  detailedLocation: any;
  detailedInsuredName: any;
  detailedProducerName: any;
  detailedInceptionDate: any;
  detailedExpiryDate: any;
  detailedGeneratedOn: any;
  allPolicyNumberDetails: any;
  detailedDataTableData: any = [];
  policyCurrencyType: any;
  dropdownSettings: IDropdownSettings = {};
  voyageTypeData = [];
  selectedItemsRoot = [];
  SOA_template = [];
  selectedPolicyData: Observable<any>;
  selected: string;
  noResult = false;
  selectedPolicy: any = [];
  isActive: any;
  searchPolicyNumber: any;

  constructor(private formBuilder: FormBuilder,
    private commonService: CommonService,
    private commonVariablesService: CommonVariablesService,
    private datePipe: DatePipe, private spinner: NgxSpinnerService,
    private http: HttpClient
  ) {
  }
  config1: any = {
    displayKey: "cust_fld_1", //if objects array passed which key to be displayed defaults to description
    search: true, //true/false for the search functionlity defaults to false,
    height: 'auto', //height of the list so that if there are more no of items it can show a scroll defaults to auto. With auto height scroll will never appear
    placeholder: 'Please Select Policy Number', // text to be displayed when no item is selected defaults to Select,
    customComparator: () => { }, // a custom function using which user wants to sort the items. default is undefined and Array.sort() will be used in that case,
    limitTo: 10,// a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    moreText: 'more', // text to be displayed whenmore than one items are selected like Option 1 + 5 more
    noResultsFound: 'No results found!', // text to be displayed when no items are found while searching
    searchPlaceholder: 'Search policy number', // label thats displayed in search input,
    searchOnKey: "cust_fld_1"
  }
  ngOnInit(): void {
    this.selectedPolicyData = new Observable((observer: Observer<string>) => {
      observer.next(this.selected);

    })
      .pipe(
        switchMap((query: string) => {
          return from(this.getPolicyNumbers(query)).pipe(
            map((data: any) => data || []),
            tap(() => noop, err => { console.log('Something goes wrong'); })
          );
        })
      );
    window.localStorage.setItem('pageName', '');
    this.detailedSOAForm = this.formBuilder.group({
      detailedPolicyNumber: ['', Validators.required],
      voyageType: ['', Validators.required],
      detailedFromDate: ['', Validators.required],
      detailedToDate: ['', Validators.required],
      detailedLocation: [''],
      detailedInsuredName: [''],
      detailedProducerName: [''],
      detailedInceptionDate: [''],
      detailedExpiryDate: [''],
      detailedGeneratedDate: ['']
    });
    this.dtOptions = {
      dom: "ftipr",
      destroy: true,
      //order: [[0, "asc"]],
      bSort: false,
    }
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 5,
      allowSearchFilter: true
    };
    //this.spinner.show();
    //this.getPolicyNumbers();
    $('#detaileDataTable').DataTable({
      destroy: true,
      "paging": false
    });
  }
  get f() { return this.detailedSOAForm.controls; }
  /*
    * Created By : Manasa R
    * Description : on submiting the form loades the DataTable data.
    *********************************************/
  async onSubmit() {

    let fromdate = new Date(this.datePipe.transform(this.detailedFromDate, 'yyyy-MM-dd') + 'T00:00:00Z');
    let todate = new Date(this.datePipe.transform(this.detailedToDate, 'yyyy-MM-dd') + 'T00:00:00Z');
    let inceptionDate = new Date(this.detailedInceptionDate + 'T00:00:00Z');
    let expiryDate = new Date(this.detailedExpiryDate + 'T00:00:00Z');
    let formatedFromDate = this.datePipe.transform(this.detailedFromDate, 'yyyy-MM-dd');
    let formatedToDate = this.datePipe.transform(this.detailedToDate, 'yyyy-MM-dd');
    if (fromdate < inceptionDate || fromdate > expiryDate) {
      //alert("From Date Should be Greater than Inception date and Less than Expiry date")
      this.commonService.errorsmsg('From Date Should be Greater than Inception date and Less than Expiry date', 'Error');
      return;
    }
    else if (todate < inceptionDate || todate > expiryDate) {
      //alert("To Date Should be Greater than Inception date and Less than Expiry date")
      this.commonService.errorsmsg('To Date Should be Greater than Inception date and Less than Expiry date', 'Error');
      return;
    }
    else if (this.detailedSOAForm.invalid) {
      this.submitted = true;
      return;
    }
    else {
      this.detailedDataTableData = [];
      this.spinner.show();
      let selectedVoyageType = '';
      for (let i = 0; i < this.detailedSOAForm.value.voyageType.length; i++) {
        if (selectedVoyageType == '')
          selectedVoyageType = this.detailedSOAForm.value.voyageType[i].id;
        else
          selectedVoyageType = selectedVoyageType + ',' + this.detailedSOAForm.value.voyageType[i].id;
      }
      let param = {
        //policy_ref_num: this.detailedSOAForm.value.detailedPolicyNumber.policy_ref_num,
        policy_ref_num: this.selectedPolicy.policy_ref_num,
        from_date: formatedFromDate, to_date: formatedToDate, policy_no: this.selectedPolicyNumber,
        voyage: selectedVoyageType
      }
      $('#detaileDataTable').DataTable().destroy();
      let url = this.commonVariablesService.baseURL + "api/v1/marine_soa/statements/detailed";
      let response = await this.commonService.httpGetMethod(url, '', true, param, 'Detailed Statement Of Accounts');
      if (response.status == 0) {
        this.spinner.hide();

        for (let i = 0; i < response.data.length; i++) {
          let dateVal: any = "";

          let policyInceptionDate = response.data[i].policyInceptionDate_EndtEffectiveDate_DeclarationDate

          /* if (policyInceptionDate != "" && policyInceptionDate != undefined){
			let s_date=policyInceptionDate.split("-");
			let d=s_date[2],m=s_date[1],y=s_date[0]; */
          /* let date = d+'/'+m+'/'+y; */
          dateVal = policyInceptionDate;
          /* }
              else
                dateVal = ""; */

          if (response.data[i].opening_bal_of_SI != undefined && response.data[i].opening_bal_of_SI != '')
            response.data[i].opening_bal_of_SI = formatNumber((response.data[i].opening_bal_of_SI.toString()).replace(',', ''), 'en-US', '.2');
          else
            response.data[i].opening_bal_of_SI = "";
          if (response.data[i].increase_Decrease_in_SI != undefined && response.data[i].increase_Decrease_in_SI != '')
            response.data[i].increase_Decrease_in_SI = formatNumber((response.data[i].increase_Decrease_in_SI.toString()).replace(',', ''), 'en-US', '.2');
          else
            response.data[i].increase_Decrease_in_SI = "";
          if (response.data[i].closing_Bal_of_SI != undefined && response.data[i].closing_Bal_of_SI != '')
            response.data[i].closing_Bal_of_SI = formatNumber((response.data[i].closing_Bal_of_SI.toString()).replace(',', ''), 'en-US', '.2');
          else
            response.data[i].closing_Bal_of_SI = "";
          if (response.data[i].premium_for_covered_declaration != undefined && response.data[i].premium_for_covered_declaration != '') {
            // if(!response.data[i].premium_for_covered_declaration.includes(","))
            response.data[i].premium_for_covered_declaration = formatNumber((response.data[i].premium_for_covered_declaration.toString()).replace(',', ''), 'en-US', '.2');
          }
          else
            response.data[i].premium_for_covered_declaration = "";
          if (response.data[i].opening_balance_of_premium != undefined && response.data[i].opening_balance_of_premium != '')
            response.data[i].opening_balance_of_premium = formatNumber((response.data[i].opening_balance_of_premium.toString()).replace(',', ''), 'en-US', '.2');
          else
            response.data[i].opening_balance_of_premium = "";
          if (response.data[i].increase_Decrease_in_premium != undefined && response.data[i].increase_Decrease_in_premium != '')
            response.data[i].increase_Decrease_in_premium = formatNumber((response.data[i].increase_Decrease_in_premium.toString()).replace(',', ''), 'en-US', '.2');
          else
            response.data[i].increase_Decrease_in_premium = "";
          if (response.data[i].closing_balance_of_premium != undefined && response.data[i].closing_balance_of_premium != '')
            response.data[i].closing_balance_of_premium = formatNumber((response.data[i].closing_balance_of_premium.toString()).replace(',', ''), 'en-US', '0.2');
          else
            response.data[i].closing_balance_of_premium = "";
          if (response.data[i].actual_declaration != undefined && response.data[i].actual_declaration != '') {
            //if(!response.data[i].actual_declaration.includes(","))
            response.data[i].actual_declaration = formatNumber((response.data[i].actual_declaration.toString()).replace(',', ''), 'en-US', '0.2');

          }
          else
            response.data[i].actual_declaration = "";
          if (response.data[i].declaration_covered != undefined && response.data[i].declaration_covered != '')
            response.data[i].declaration_covered = formatNumber((response.data[i].declaration_covered.toString()).replace(',', ''), 'en-US', '0.2');
          else
            response.data[i].declaration_covered = ""
          var data = {
            transaction_date: response.data[i].transaction_date || "",
            draft_certificate_bulk_declaration_number: response.data[i].draft_certificate_bulk_declaration_number || "",
            transaction_type: response.data[i].transaction_type || "",
            voyage_name: response.data[i].voyage_name || "",
            policyInceptionDate_EndtEffectiveDate_DeclarationDate: dateVal,
            declaration_period: response.data[i].declaration_period || "",
            actual_declaration: response.data[i].actual_declaration || "",
            declaration_covered: response.data[i].declaration_covered || "",
            opening_bal_of_SI: response.data[i].opening_bal_of_SI || "",
            increase_Decrease_in_SI: response.data[i].increase_Decrease_in_SI || "",
            closing_Bal_of_SI: response.data[i].closing_Bal_of_SI || "",
            premium_for_covered_declaration: response.data[i].premium_for_covered_declaration || "",
            opening_balance_of_premium: response.data[i].opening_balance_of_premium || "",
            increase_Decrease_in_premium: response.data[i].increase_Decrease_in_premium || "",
            closing_balance_of_premium: response.data[i].closing_balance_of_premium || "",
          }
          this.detailedDataTableData.push(data);
        }
      }
      else if (response.status != -114) {
        $('#detaileDataTable').DataTable().destroy();
        this.dtTrigger.next();
        this.commonService.errorsmsg(response.txt, 'Error');
        this.spinner.hide();
      }
      this.dtTrigger.next();
    }
  }

  /*
    * Created By : Manasa R
    * Description : Reset the form data.
    *********************************************/
  onReset() {
    //this.ngxselectRef._value = [];
    this.selected = '';
    this.detailedSOAForm.reset();
    this.detailedDataTableData = [];
    this.selectedItemsRoot = [];
    $('#detaileDataTable').DataTable().destroy();
    this.dtTrigger.next();
    this.submitted = false;
  }
  /*
    * Created By : Manasa R
    * Description : To get unique policy numbers from given object.
    *********************************************/
  unique(obj) {
    let newArray = [];
    let uniqueObject = {};
    for (let i in obj) {
      let objTitle = obj[i]['policy_ref_num'];
      if (obj[i].renewal_counter)
        obj[i].cust_fld_1 = obj[i].cust_fld_1 + ' - ' + obj[i].renewal_counter;
      uniqueObject[objTitle] = obj[i];
    }
    for (let i in uniqueObject) {
      newArray.push(uniqueObject[i]);
    }
    return newArray;
  }
  onPolicyNumberDropdown() {
    //this.tempPolicyNumberDetails = JSON.parse(JSON.stringify(this.policyNumberDropdown))
    this.config1 = {
      displayKey: "cust_fld_1",
      search: true,
      height: 'auto',
      placeholder: 'Please Select Policy Number',
      customComparator: () => { },
      limitTo: 10,
      moreText: 'more',
      noResultsFound: 'No results found!',
      searchPlaceholder: 'Search policy number',
      clearOnSelection: true,
      searchOnKey: "cust_fld_1"
    }
  }
  selectedPolicyNumber: any;
  /*
    * Created By : Manasa R
    * Description : On changing the policy number data gets changed in form fields .
    *********************************************/
  async onChangeOfPolicyNumber() {
    let policyRefNumber = this.selectedPolicy;;
    let policyNumber = policyRefNumber.cust_fld_1.split('-');
    this.voyageTypeData = [];
    this.selectedItemsRoot = [];
    let url = this.commonVariablesService.baseURL + "api/v1/marine_soa/policy_list?"
    if (policyRefNumber != undefined) {
      let params = {
        policy_no: policyNumber[0],
        policy_ref_num: policyRefNumber.policy_ref_num,
        module_name: 'SOA'
      }
      let response = await this.commonService.httpGetMethod(url, '', true, params, 'Simple SOA');
      if (response.status == 0) {
        if (response.data.length > 0) {
          this.selectedPolicyNumber = response.data[0].cust_fld_1;
          this.detailedFromDate = new Date(response.data[0].policy_start_date)
          this.detailedToDate = new Date()
          this.detailedLocation = response.data[0].location
          this.detailedInsuredName = response.data[0].insured
          this.detailedProducerName = response.data[0].producer
          this.detailedInceptionDate = response.data[0].policy_start_date
          this.detailedExpiryDate = response.data[0].policy_end_date
          this.policyCurrencyType = response.data[0].policy_currency_type;
          let systemDate = new Date();
          let currentDate = this.datePipe.transform(systemDate, "dd-MM-yyyy HH:mm:ss");
          this.detailedGeneratedOn = currentDate + ' / ' + window.localStorage.getItem("name");
          let voyageData = [];
          for (let j = 0; j < response.data[0].voyages.length; j++) {
            voyageData.push({ 'id': response.data[0].voyages[j].value, 'name': response.data[0].voyages[j].name })
          }
          this.voyageTypeData = voyageData
          this.detailedSOAForm.patchValue({
            voyageType: voyageData
          })
        }
        else {
          this.commonService.errorsmsg('No data Available', 'Error');
        }
      }
      else if (response.status != -114) {
        this.commonService.errorsmsg(response.txt, 'Error');
      }
    }
    this.detailedDataTableData = [];
    $('#detaileDataTable').DataTable().destroy();
    this.dtTrigger.next();

  }
  /*
    * Created By : Manasa R
    * Description : gets the policy numbers from server.
    *********************************************/
  async getPolicyNumbers(policyNo) {
    this.searchPolicyNumber = policyNo;
    if (policyNo.length >= 6) {
      this.spinner.show();
      this.allPolicyNumberDetails = [];
      let url = this.commonVariablesService.baseURL + 'api/v1/marine_soa/policy_list';
      let params = {
        policy_no: policyNo,
        module_name: 'SOA'
      }
      let response = await this.commonService.httpGetMethod(url, '', true, params, 'Detailed Statement Of Accounts');
      if (response.status == 0) {
        this.spinner.hide();
        for (let i in response.data) {
          response.data[i].search_val = (response.data[i].cust_fld_1 || '');
        }
        //this.allPolicyNumberDetails = this.unique(response.data);
        return this.unique(response.data);
      }
      // else if (response.status != -114) {
      //   this.commonService.errorsmsg(response.txt, 'Error');
      //   this.spinner.hide();
      // }
    }
  }
  /*
    * Created By : Manasa R
    * Description : To generate PDF.
    *********************************************/
  async generatePdf() {
    if (this.detailedDataTableData.length == 0) {
      this.commonService.warningmsg('No data available in table', 'worning');
      return;
    }
    //$('#detaileDataTable').DataTable({"pageLength":this.detailedDataTableData.length })
    //   let formatedFromDate = this.datePipe.transform(this.detailedFromDate, 'yyyy/MM/dd');
    //   let formatedToDate = this.datePipe.transform(this.detailedToDate, 'yyyy/MM/dd');
    //   const policyDwnldUrl = `${this.commonVariablesService.baseURL}api/v1/marine_download/pdf/marine_soa_detail/${this.selectedPolicyNumber}?token=${encodeURIComponent(sessionStorage.getItem('token'))}&policy_ref_num=${this.detailedSOAForm.value.detailedPolicyNumber.policy_ref_num}&from_date=${formatedFromDate}&to_date=${formatedToDate}&policy_no=${this.selectedPolicyNumber}`;
    // window.open(policyDwnldUrl, '_blank');
    let l: any = {
      orientation: 'l',
      unit: 'mm',
      //format: 'a4',
      format: [425, 210],
      compress: true,
      fontSize: 9,
      lineHeight: 1,
      autoSize: false,
      printHeaders: true
    };
    let selectedVoyageType = '';
    for (let i = 0; i < this.detailedSOAForm.value.voyageType.length; i++) {
      if (selectedVoyageType == '')
        selectedVoyageType = this.detailedSOAForm.value.voyageType[i].name;
      else
        selectedVoyageType = selectedVoyageType + ',' + this.detailedSOAForm.value.voyageType[i].name;
    }

    const doc = new jsPDF(l);

    /* doc.text('Tagic Marine', 10, 5, { align: "left" }); */
    doc.text("Policy Number : " + this.selectedPolicyNumber, 10, 10, { align: 'left' })
    doc.text("Voyage Type : " + selectedVoyageType, 10, 15, { align: 'left' })
    doc.text("From Date : " + this.datePipe.transform(this.detailedFromDate, 'dd-MM-yyyy'), 10, 20, { align: 'left' })
    doc.text("To Date : " + this.datePipe.transform(this.detailedToDate, 'dd-MM-yyyy'), 10, 25, { align: 'left' })
    doc.text("Location : " + this.detailedLocation, 10, 35, { align: 'left' })
    doc.text("Insured Name : " + this.detailedInsuredName, 10, 40, { align: 'left' })
    doc.text("Producer Name : " + this.detailedProducerName, 10, 45, { align: 'left' })
    doc.text("Generated On / By : " + this.detailedGeneratedOn, 10, 50, { align: 'left' })
    doc.text("Policy Inception Date : " + this.datePipe.transform(this.detailedInceptionDate, "dd-MM-yyyy"), 10, 55, { align: 'left' })
    doc.text("Policy Expiry Date : " + this.datePipe.transform(this.detailedExpiryDate, "dd-MM-yyyy"), 10, 60, { align: 'left' })
    doc.text("DETAILED STATEMENT OF ACCOUNT", 10, 65, { align: 'left' })
    let rowsplit: "auto" | "avoid" = "avoid";
    //let themeForTable:'striped'|'grid'|'plain'|'css' = 'striped'
    let options = {
      // html: '#detaileDataTable',
      //tableLineColor: 'black',
      //tableLineWidth: 0.25,
      body: this.detailedDataTableData,
      //theme:themeForTable,
      columns: [
        { header: 'Transaction Date', dataKey: 'transaction_date' },
        { header: 'Draft/Certificate/Bulk declaration number', dataKey: 'draft_certificate_bulk_declaration_number' },
        { header: 'Transaction type', dataKey: 'transaction_type' },
        { header: 'Voyage Type', dataKey: 'voyage_name' },
        { header: 'Policy Inception Date/Endt Effective Date/Declaration  Date', dataKey: 'policyInceptionDate_EndtEffectiveDate_DeclarationDate' },
        { header: 'Declaration Period', dataKey: 'declaration_period' },
        { header: 'Actual Declaration', dataKey: 'actual_declaration' },
        { header: 'Declaration Covered', dataKey: 'declaration_covered' },
        { header: 'Opening Bal of SI in ' + this.policyCurrencyType, dataKey: 'opening_bal_of_SI' },
        { header: 'Increase / Decrease in SI', dataKey: 'increase_Decrease_in_SI' },
        { header: 'Closing Bal of SI in ' + this.policyCurrencyType, dataKey: 'closing_Bal_of_SI' },
        { header: 'Premium for Covered declaration in ' + this.policyCurrencyType, dataKey: 'premium_for_covered_declaration' },
        { header: 'Opening balance of premium in ' + this.policyCurrencyType, dataKey: 'opening_balance_of_premium' },
        { header: 'Increase / Decrease in Premium', dataKey: 'increase_Decrease_in_premium' },
        { header: 'Closing balance of premium', dataKey: 'closing_balance_of_premium' },
      ],
      rowPageBreak: rowsplit,
      bodyStyles: {
        lineWidth: 0.1, fontSize: 9,
        lineColor: 'gray'
      }, headerStyles: {
        halign: 'center', lineWidth: 0.1, fontSize: 9,
        lineColor: 'gray',
      }
      //includeHiddenHtml:true,
      /* columnStyles: {
        0: { cellWidth: 14 },
        1: { cellWidth: 14 },
        2: { cellWidth: 14 }, 3: { cellWidth: 13 }, 4: { cellWidth: 16 }, 5: { cellWidth: 12 }, 6: { cellWidth: 12 },
        7: { cellWidth: 14 },
        8: { cellWidth: 11 },
        9: { cellWidth: 13 },
        10: { cellWidth: 11 },
        11: { cellWidth: 18 },
        12: { cellWidth: 18 },
        13: { cellWidth: 14 },
        14: { cellWidth: 14 }
      } */, margin: { right: 1, left: 1, top: 75 }, didDrawPage: function (data) {
        // Reseting top margin. The change will be reflected only after print the first page.
        data.settings.margin.top = 10;
      },
    }
    //doc.text('Tagic Marine',10,10,options);

    autoTable(doc, options)
    doc.save(this.selectedPolicyNumber + "_Detailed_SOA.pdf")


  }
  /*
    * Created By : Manasa R
    * Description : To generate Excel.
    *********************************************/
  async  generateExcel() {
    //font,color,image,size
    if (this.detailedDataTableData.length == 0) {
      this.commonService.warningmsg('No data available in table', 'worning');
      return;
    }
    setTimeout(async () => {
      (this.spinner.show());
    }, 1000);
    let selectedVoyageType = '';
    for (let i = 0; i < this.detailedSOAForm.value.voyageType.length; i++) {
      if (selectedVoyageType == '')
        selectedVoyageType = this.detailedSOAForm.value.voyageType[i].name;
      else
        selectedVoyageType = selectedVoyageType + ',' + this.detailedSOAForm.value.voyageType[i].name;
    }
    var datajson = { datajson1: this.detailedDataTableData };
    /*var Heading = [
      ["DETAILED STATEMENT OF ACCOUNT"],
      [],
      ["Policy Number", this.selectedPolicyNumber + "" || ''],
      ["Voyage Type", selectedVoyageType + "" || ''],
      ["From Date", this.datePipe.transform(this.detailedFromDate, "dd/MM/yyyy") || ''],
      ["To Date", this.datePipe.transform(this.detailedToDate, "dd/MM/yyyy") || ''],
	  ["Location " , this.detailedLocation + "" || ''],
	  ["Insured Name", this.detailedInsuredName + "" || ''],
	  ["Producer Name", this.detailedProducerName + "" || ''],
	  ["Generated On / By", this.detailedGeneratedOn + "" || ''],
	  ["Policy Inception Date", this.datePipe.transform(this.detailedInceptionDate, "dd/MM/yyyy") + "" || ''],
	  ["Policy Expiry Date", this.datePipe.transform(this.detailedExpiryDate, "dd/MM/yyyy") + "" || ''],
      [],
      ["Transaction Date",
        "Draft/Certificate/Bulk declaration number",
        "Transaction type",
        "Voyage Type",
        "Policy Inception Date/Endt Effective Date/Declaration Date",
        "Declaration Period",
        "Actual Declaration",
        "Declaration Covered",
        "Opening Bal of SI in " + this.policyCurrencyType,
        "Increase / Decrease in SI",
        "Closing Bal of SI in " + this.policyCurrencyType, ,
        "Premium for Covered declaration in " + this.policyCurrencyType, ,
        "opening balance of premium in " + this.policyCurrencyType, ,
        "Increase / Decrease in Premium",
        "Closing balance of premium"]
    ];

    const merge = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 15 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: 15 } },
      { s: { r: 2, c: 0 }, e: { r: 2, c: 15 } },
      //{ s: { r: 6, c: 0 }, e: { r: 6, c: 15 } } 
    ];
    var wscols = [];
    let cell;
    for (let i = 0; i < Heading[2].length; i++) {
      wscols.push({ wch: 25 });  // Common column width
    }
    var ws = XLSX.utils.json_to_sheet(Heading);
    ws['!cols'] = wscols;
    ws["!merges"] = merge;
    ws["A1"] = {
      "t": 's',
      "v": 'TATA MARINE',
      "s": { bgColor: "#17375E" }
    };
    ws["A4"].s={ bgcolor: "#17375E", style: "text-align:center"}
    // ws["A1"].s={ size: 20, bold: true, color: "#e012e0", style: "text-align:center"}
    XLSX.utils.sheet_add_json(ws, datajson.datajson1, {
      skipHeader: true,
      origin: -1,

    });
    // var alphabets = [''];
    var wb = XLSX.utils.book_new();
    await (XLSX.utils.book_append_sheet(wb, ws, "Detailed SOA"));
    XLSX.writeFile(wb, this.selectedPolicyNumber+'_Detailed_SOA.xlsx');*/

    await this.loadAndWriteXLXS(datajson, this.selectedPolicyNumber + '_Detailed_SOA.xlsx')

    setTimeout(async () => {
      (this.spinner.hide());
    }, 1000);
  }

  async loadAndWriteXLXS(jsonData, fileName) {
    const fn = 'Detailed_SOA_template_29112020115100.xlsx'
    const path = `assets/excel/${fn}`;

    let selectedVoyageType = '';
    for (let i = 0; i < this.detailedSOAForm.value.voyageType.length; i++) {
      if (selectedVoyageType == '')
        selectedVoyageType = this.detailedSOAForm.value.voyageType[i].name;
      else
        selectedVoyageType = selectedVoyageType + ',' + this.detailedSOAForm.value.voyageType[i].name;
    }

    /* let time = this.detailedGeneratedOn.split(" / ")[0];
    let username = this.detailedGeneratedOn.split("/")[1]; */

    const placeholders = {};
    placeholders['<<policy_number>>'] = this.selectedPolicyNumber;
    placeholders['<<voyage_type>>'] = selectedVoyageType;
    placeholders['<<from_date>>'] = this.datePipe.transform(this.detailedFromDate, "dd-MM-yyyy");
    placeholders['<<to_date>>'] = this.datePipe.transform(this.detailedToDate, "dd-MM-yyyy");
    placeholders['<<location>>'] = this.detailedLocation;
    placeholders['<<insured_name>>'] = this.detailedInsuredName;
    placeholders['<<producer_name>>'] = this.detailedProducerName;
    placeholders['<<generated_on_by>>'] = this.detailedGeneratedOn;
    placeholders['<<inception_date>>'] = this.datePipe.transform(this.detailedInceptionDate, "dd-MM-yyyy");
    placeholders['<<expiry_date>>'] = this.datePipe.transform(this.detailedExpiryDate, "dd-MM-yyyy");
    placeholders['<<policy_currency>>'] = this.policyCurrencyType;

    await this.http.get(path, { responseType: 'blob' }).subscribe(async (data: any) => {
      const reader: FileReader = new FileReader();
      reader.readAsBinaryString(data);
      reader.onload = async (e: any) => {
        /* create workbook */
        const binarystr: string = e.target.result;

        const workbook = new Excel.Workbook();
        const wb = await workbook.xlsx.load(binarystr);
        let MainSheet = wb.worksheets[0];

        for (let col = 1; col <= MainSheet.columnCount; col++) {
          MainSheet.getColumn(col).eachCell(function (item) {
            if ((item.value || "") != "") {
              var matches = ((item.value || "") + "").match(/<<(.*)>>/g);
              if (matches) {
                matches.forEach(function (templateStringToReplace) {
                  item.value = item.value.replace(templateStringToReplace, placeholders[templateStringToReplace])
                });
              }
            }
          });
        }
        let rowWithoutData = MainSheet.rowCount;
        for (let item of jsonData.datajson1) {
          MainSheet.addRow(Object.values(item));
        }

        let border_style = { "border": { "left": { "style": "thin", "color": { "indexed": 64 } }, "right": { "style": "thin", "color": { "indexed": 64 } }, "top": { "style": "thin", "color": { "indexed": 64 } }, "bottom": { "style": "thin", "color": { "indexed": 64 } } }, "fill": { "type": "pattern", "pattern": "none" } }
        for (let row = rowWithoutData + 1; row <= MainSheet.rowCount; row++) {
          MainSheet.getRow(row).eachCell(item => {
            item.style = { ...item.style, ...border_style }
          });
        }

        for (let index of [3, 4, 6, 9, 11]) {
          let tmp_value = MainSheet.getColumn(index).values;
          let size = tmp_value.slice(14).map(item => { return item.length }).sort((a, b) => { return b - a })[0];
          //skip empty value
          if (size > 0) {
            MainSheet.getColumn(index).width = size + 0.21;
          }
        }

        await workbook.xlsx.writeBuffer().then(async function (workbookData) {
          const blob = new Blob([workbookData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
          FileSaver.saveAs(blob, fileName);
        });
      }
    }, error => {
    });
  }

  typeaheadNoResults(event: boolean): void {
    if (this.searchPolicyNumber.length >= 6) {
      this.noResult = event;
    }
  }

	/*
	* Created By : Keerthana T
	* Description : Renders the data in the field
	*********************************************/
  async typeaheadOnSelect(e: any, isManuallyTrigger: boolean = false) {
    this.selectedPolicy = [];
    this.selected = e.value ? e.value : "";
    this.selectedPolicy = e.item
    await this.onChangeOfPolicyNumber()
  }
}
